import React, { useState, useEffect } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { Link } from "react-router-dom";
import {
  getAllDepartmentDetailslist,
  getAllMyDepartmentDetailslist,
  getActiveDepartment,
} from "../../../service/Department/DepartmentService";
import ReactPaginate from "react-paginate";
import SpinnerComponent from "../../components/SpinnerComponent";
import { toBeRequired } from "@testing-library/jest-dom/matchers";
import { useTranslation } from "react-i18next";

const Department = () => {
  const { t } = useTranslation();
  const [departmentList, setAllDepartmentList] = useState([]);
  const [myDepartmentList, setAllMyDepartmentList] = useState([]);
  const [search, setSearch] = useState("");
  const [department, setDepartment] = useState("");

  const [isActive, setActive] = useState("false");
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const PER_PAGE = 10;

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const offset = currentPage * PER_PAGE;
  const currentPageData = departmentList.slice(offset, offset + PER_PAGE);

  const pageCount = Math.ceil(departmentList?.length / PER_PAGE);

  const handleToggle = (id, isActive) => {
    setIsLoading(toBeRequired);
    getActiveDepartment("Department", id, isActive ? false : true, (r) => {
    //  console.log(r, "response");
      if (r.success === true) {
        getDepartmentDataList();
        setIsLoading(false);
      } else {
        setIsLoading(false);
        // toast.error(r.message)
      }
    });
  };
  const onSearch = (e) => {
    setIsLoading(true);
    setSearch(e.target.value);
    getAllDepartmentDetailslist(e.target.value).then(function (result) {
    //  console.log(result.data, "datadatadatadatada");
      const response = result.data;
    //  console.log(response, "rrrr");
      setAllDepartmentList(response?.data?.departmentList);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    getDepartmentDataList();
  }, []);

  async function getDepartmentDataList() {
    setIsLoading(true);
    getAllDepartmentDetailslist(search, "").then(function (result) {
    //  console.log(result.data, "datadatadatadatada");
      const response = result.data;
    //  console.log(response, "rrrr");
      setAllDepartmentList(response?.data?.departmentList);
      setIsLoading(false);
    });
  }

  useEffect(() => {
    getMyDepartmentDataList();
  }, []);

  async function getMyDepartmentDataList() {
    setIsLoading(true);
    getAllMyDepartmentDetailslist().then(function (result) {
    //  console.log(result.data, "datadatadatadatada");
      const response = result.data;
    //  console.log(response, "rrrr");
      setAllMyDepartmentList(response?.data?.departmentList);
      setIsLoading(false);
    });
  }

  const onDepartment = (e) => {
    setIsLoading(true);
    setDepartment(e.target.value);
    getAllDepartmentDetailslist(search, e.target.value).then(function (result) {
    //  console.log(result.data, "datadatadatadatada");
      const response = result.data;
    //  console.log(response, "rrrr");
      setAllDepartmentList(response?.data?.departmentList);
      setIsLoading(false);
    });
  };

  const _RESET = (e) => {
    setIsLoading(true);
    e.preventDefault();
    getAllDepartmentDetailslist("", "").then(function (result) {
      const response = result.data;
      setAllDepartmentList(response?.data?.departmentList);
      setIsLoading(false);
      setSearch("");
      setDepartment("");
    });
  };

  return (
    <div className="container-fluid">
      <div className="dbMain departMent">
        <Leftpanel breadcm={t("configuration")} />
        <div className="dbRight">
          <Header
            link="/dashboard"
            breadcm={`${t("configuration")} > `}
            title={t("departments")}
            description=""
          />
          <div className="commonBase">
            <div className="dbtableTop">
              <div className="dbSearch">
                <input
                  type="search"
                  className="form-control"
                  placeholder={t("search")}
                  onChange={onSearch}
                  value={search}
                />
                <i className="fa-solid fa-magnifying-glass"></i>
              </div>
              <div className="dbtableSrchbg">
                <select className="form-control" onChange={onDepartment}>
                  <option selected={department === ""}>
                    {t("all_departments")}
                  </option>
                  {myDepartmentList?.map((d) => (
                    <option selected={d?.name === department} value={d?.id}>
                      {d?.name}
                    </option>
                  ))}
                </select>
                &nbsp;
                <button className="commonButton">
                  <Link to="/adddepartment">
                    <i className="fa-solid fa-plus"></i> {t("add_department")}
                  </Link>
                </button>
                &nbsp;
                <button className="commonButton" onClick={_RESET}>
                  {t("reset")}
                </button>
              </div>
            </div>
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>{t("business_units")}</th>
                    <th>{t("department_name")}</th>
                    <th>{t("short_name")}</th>
                    <th>{t("identification_number")}</th>
                    <th>{t("accounting_number")}</th>
                    <th>{t("country")}</th>
                    <th>{t("action")}</th>
                  </tr>
                </thead>
                {isLoading && <SpinnerComponent isLoading={isLoading} />}
                {currentPageData?.map((dept, index) => (
                  <tbody key={index}>
                    <tr className={dept?.isActive ? null : "inactive"}>
                      <td data-label={t("business_unit")}>
                        <Link
                          to={`/departmentdetl?id=${dept?.id}`}
                          style={{ color: "#0d6efd" }}
                        >
                          {dept?.BusinessUnit?.name}
                        </Link>
                      </td>
                      <td data-label={t("department_name")}>
                        <Link
                          to={`/departmentdetl?id=${dept?.id}`}
                          style={{ color: "#0d6efd" }}
                        >
                          {dept?.name}
                        </Link>
                      </td>
                      <td data-label={t("short_name")}>
                        <Link
                          to={`/departmentdetl?id=${dept?.id}`}
                          style={{ color: "#0d6efd" }}
                        >
                          {dept?.shortName}
                        </Link>
                      </td>
                      <td data-label={t("bu_identification_no")}>
                        <Link to={`javascript:void(0)`}>
                          {dept?.buIdentificationNumber}
                        </Link>
                      </td>
                      <td data-label={t("bu_gl_key")}>
                        <Link to={`javascript:void(0)`}>
                          {dept?.accountingKey}
                        </Link>
                      </td>
                      <td data-label={t("country")}>
                        <Link to={`javascript:void(0)`}>
                          {dept?.BusinessUnit?.country}
                        </Link>
                      </td>
                      <td data-label={t("action")}>
                        <button
                          onClick={() => handleToggle(dept?.id, dept?.isActive)}
                          className="beye"
                        >
                          <i className="fa-light fa-eye"></i>&nbsp;&nbsp;
                          <i className="fa-light fa-eye-slash"></i>
                        </button>
                        <Link to={`/editdepartment?id=${dept?.id}`}>
                          <i className="fa-light fa-pen"></i>
                        </Link>
                      </td>
                    </tr>
                  </tbody>
                ))}
              </table>
            </div>
            {!isLoading && (
              <ReactPaginate
                previousLabel={t("previous")}
                nextLabel={t("next")}
                pageCount={pageCount}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                previousLinkClassName={"pagination__link"}
                nextLinkClassName={"pagination__link"}
                disabledClassName={"pagination__link--disabled"}
                activeClassName={"pagination__link--active"}
                forcePage={currentPage}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Department;
